import { createApp } from 'vue'
import './assets/iconfont/iconfont.css'
import App from './App.vue'
import router from './router'
import store from './store'
import elementplus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'
import editorInitConfig from './setting/editorInitConfig'
import { quillEditor } from 'vue3-quill'

const app = createApp(App)

app.config.globalProperties.$http = axios
app.config.globalProperties.$editorInitConfig = editorInitConfig

app.config.globalProperties.$playYoudaoAiAudio = function (
  sentence,
  componentRef
) {
  this.$store
    .dispatch('Vocabulary/getYoudaoAiAudio', { sentence: sentence })
    .then(response => {
      const audioUrl = response.data.url
      componentRef.src = audioUrl
      componentRef.play()
      console.log('播放成功:', response.data)
    })
    .catch(error => {
      console.error('播放失败:', error)
    })
}

app.config.globalProperties.$playAudio = function (englishWord, componentRef) {
  return new Promise((resolve, reject) => {
    if (!componentRef) {
      reject(new Error('no audio element'))
      return
    }

    const playId = (componentRef._vocPlayId || 0) + 1
    componentRef._vocPlayId = playId
    const isStale = () => componentRef._vocPlayId !== playId

    try {
      componentRef.pause()
      componentRef.currentTime = 0
    } catch (e) {
      console.log(e)
    }

    let processedWord = String(englishWord || '').trim()
    if (processedWord.includes('/') || processedWord.includes('?')) {
      processedWord = processedWord.replace(/\//g, ' ').replace(/\?/g, '.')
    }

    // 句子（含空格）走例句合成，单词走单词发音，统一使用后端 Edge TTS
    const isSentence = processedWord.includes(' ')

    const play = audioUrl => {
      if (isStale()) return Promise.resolve()
      componentRef.src = audioUrl
      return componentRef.play()
    }

    const request = isSentence
      ? this.$store.dispatch('Vocabulary/getExampleSentenceAudio', {
          sentence: processedWord
        })
      : this.$store.dispatch('Vocabulary/getWordPronunciation', {
          word: processedWord
        })

    request
      .then(response => {
        const audioUrl = response.data.url || response.data.URL
        // 单词发音加时间戳，避免浏览器缓存旧发音（如 lead 修正后仍读旧音）；例句是 hash 文件名，无需加
        const finalUrl = isSentence
          ? audioUrl
          : audioUrl + (audioUrl.includes('?') ? '&' : '?') + 't=' + Date.now()
        return play(finalUrl)
      })
      .then(() => {
        if (!isStale()) resolve()
      })
      .catch(error => {
        if (!isStale()) reject(error)
      })
  })
}

// app.config.globalProperties.$playAudio = function (englishWord, componentRef) {
//   return new Promise((resolve, reject) => {
//     //var vocAPI = "http://listening.andover.com.cn/static/Audio/vocAudios/";
//     var vocAPI = '/vocabulary/audios/listeningAudios/vocAudios/'
//     ///vocabulary/audios/listeningAudios/
//     // hole 和 shed发音不对，替换成英音的发音，type=1
//     //if (englishWord == "hole" || englishWord == "shed" || englishWord == "loudness" || englishWord == "skier") {
//     //vocAPI = "http://dict.youdao.com/dictvoice?type=1&audio=";
//     //}
//     componentRef.src = vocAPI + englishWord + '.mp3'

//     // Event listener to resolve the promise when the audio finishes playing
//     componentRef.addEventListener('ended', () => {
//       resolve()
//     })

//     // Event listener to reject the promise if an error occurs during audio playback
//     // componentRef.addEventListener("error", (error) => {
//     //   reject(error);
//     // });

//     // Attempt to play the audio
//     componentRef.play().catch(() => {
//       console.log('Error catched and trying alternative sources')

//       // Array of alternative sources
//       const alternativeSources = [
//         'http://dict.youdao.com/dictvoice?type=0&audio=' + englishWord,
//         'http://dict.youdao.com/dictvoice?type=1&audio=' + englishWord,
//       ]

//       // Try alternative sources one by one
//       ;(function tryNextSource (index) {
//         if (index < alternativeSources.length) {
//           componentRef.src = alternativeSources[index]
//           componentRef.play().catch(() => {
//             console.log('Error catched for alternative source ' + index)
//             tryNextSource(index + 1)
//           })
//         } else {
//           // No more alternative sources, reject the promise
//           reject(new Error('All alternative sources failed'))
//         }
//       })(0)
//     })
//   })
// }

// app.config.globalProperties.$playTextWithAI = function (text, audioRef) {
//   this.$store
//     .dispatch('YoudaoAI/fetchTTS', { text: text })
//     .then(audioUrl => {
//       audioRef.src = audioUrl
//       audioRef.play()
//     })
//     .catch(error => {
//       console.error('播放失败:', error)
//       alert('语音合成失败')
//     })
// }

//axios.defaults.baseURL = "http://106.14.158.100:9000";

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.withCredentials = true
      // 只追加 Authorization，不要整体替换 headers（会丢掉 Content-Type）
      // 切勿设置 Content-Encoding: gzip（正文未压缩时，大请求体会被 nginx 打成 500，浏览器表现为 CORS）
      if (!config.headers) config.headers = {}
      config.headers.Authorization = 'Bearer ' + token
      if (config.headers['Content-Encoding']) {
        delete config.headers['Content-Encoding']
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    if (response.status == 401) {
      localStorage.removeItem('token')
      router.push('/login')
    }

    return Promise.resolve(response)
  },
  function (error) {
    if (error.response) {
      if (error.response.status == 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }
    }

    return Promise.reject(error)
  }
)

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token')) {
    next()
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }

  //meta.title 对应routes路径配置文件中的meta对象；把页面的title变成meta里设置的title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // in case that student click back route to return to practice page for answering question again
  // if (from.path == "/answerresult") {
  //   next("/list");
  // }
})

//for element plus icon import
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store).use(router).use(elementplus).use(quillEditor).mount('#app')
